import type { FlatMapping } from "@/types/ui"

/**
 * Shared utility functions for mapping operations to avoid repeated filtering/mapping
 */

export const getMappedFieldNames = (mappings: FlatMapping[]): string[] => 
  mappings.filter(m => m.isMapped).map(m => m.destinationField)

export const getValidMappedFieldNames = (mappings: FlatMapping[]): string[] => 
  mappings.filter(m => m.isMapped && !m.isInvalid).map(m => m.destinationField)

export const getMappedFields = (mappings: FlatMapping[]): FlatMapping[] =>
  mappings.filter(m => m.isMapped)

export const getValidMappedFields = (mappings: FlatMapping[]): FlatMapping[] =>
  mappings.filter(m => m.isMapped && !m.isInvalid)

export const countMappedFields = (mappings: FlatMapping[]): number =>
  mappings.filter(m => m.isMapped).length

export const countValidMappedFields = (mappings: FlatMapping[]): number =>
  mappings.filter(m => m.isMapped && !m.isInvalid).length
